import Cookies from 'js-cookie';

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
function gtag(...args: any[]) {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export const markConsentAndDate = (date: string) => {
  Cookies.set('cookies_consent', true.toString(), { expires: 365 });
  Cookies.set('cookies_consent_given', date, {
    expires: 365,
  });
};

export type Storages =
  | 'analytics_storage'
  | 'ad_storage'
  | 'personalisation_storage'
  | 'ad_user_data'
  | 'ad_personalization';

export const setDefaultConsents = () => {
  /* eslint-disable camelcase */
  gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    personalisation_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 1_000,
  });
  /* eslint-enable camelcase */

  window.dataLayer.push({
    event: 'consent_default_set',
  });
};

export const agreeToAll = () => {
  Cookies.set(`cookies_consent_ad_storage`, true.toString(), {
    expires: 365,
  });
  Cookies.set(`cookies_consent_analytics_storage`, true.toString(), {
    expires: 365,
  });

  /* eslint-disable camelcase */
  updateConsents({
    ad_storage: 'granted',
    analytics_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    personalisation_storage: 'granted',
  });
  /* eslint-enable camelcase */
};

export const updateConsents = (consents: {
  ad_storage: 'granted' | 'denied';
  analytics_storage: 'granted' | 'denied';
  personalisation_storage: 'granted' | 'denied';
  ad_user_data: 'granted' | 'denied';
  ad_personalization: 'granted' | 'denied';
}) => {
  gtag('consent', 'update', consents);

  window.dataLayer.push({
    event: 'consent_updated',
  });
};
